import { Component, Input } from '@angular/core';
import { AuthService } from '@app/core/services/auth/auth.service';

@Component({
  standalone: false,
    selector: 'app-session-modal',
    templateUrl: './session-modal.component.html',
    styleUrls: ['./session-modal.component.scss']
})
export class SessionModalComponent {
    @Input() public close = () => {
        // noop - default implementation, overridden by parent
    };

    constructor(
        private authService: AuthService) { }

    redirectToLogin() {
        this.authService.logout(true);
        this.close();
    }
}
